import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleMasterOnPaqueteria: IAbstractModule = {
  type: IModuleType.master,
  name: 'Master 3 (on pack)',
  hasScreen: true,
  columns: [
    [
      {
        name: "T15",
        connector: "19",
        cell_size_id: 4,
        accessible: false,
      },
      {
        name: "T16",
        connector: "20",
        cell_size_id: 4,
        accessible: true,
      },
      {
        name: "T18",
        connector: "21",
        cell_size_id: 4,
        accessible: false,
      },
    ],
  ]
};
